import loadable from '@loadable/component';

const DataAnalytics = loadable(() => import('./page'));
const DataAnalyticsNewPage = loadable(() => import('./new/page'));
const DataAnalyticsDetailPage = loadable(() => import('./[id]/page'));


export const routes = [
  {
    path: '',
    element: <DataAnalytics />,
  },
  {
    path: 'new',
    element: <DataAnalyticsNewPage />,
  },
  {
    path: ':id',
    element: <DataAnalyticsDetailPage />,
  }
];